<template lang="pug">
v-flex 
  v-card
    v-card-title Tipos de usuario
      v-spacer
      v-text-field(v-model='search' append-icon='fa-search' label='Buscar tipo de usuario' single-line hide-details)
      v-dialog(v-model='UserType.dialog' max-width='500px')
        template(v-slot:activator='{ on }')
          v-btn.mb-2(color='primary' dark='' v-on='on' @click='clearForm()') Añadir
        v-card
          v-card-title
            span.headline {{ title }}
          v-card-text
            v-container(grid-list-md='')
              v-layout(wrap='')
                v-flex(xs12)
                  v-text-field(v-model='data.name' label='Nombre')
          v-card-actions
            v-spacer
            v-btn(color='primary' @click='save()') {{ titleButton }}
    v-data-table.elevation-1(:headers='headers' :items=' userTypeRecord' :search='search')
      template(v-slot:items='props')
        td {{ props.item.name }}
        td {{ props.item.createdAt }}
        td.justify-center.layout.px-0
          v-btn(color='secondary' icon @click='editItem(props.item.key)')
            v-icon(small) far fa-edit
          v-btn(color='secondary' icon @click='deleteItem(props.item.key)')
            v-icon(small) far fa-trash-alt
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
  data: () => ({
    search: '',
    headers: [
      { text: 'Nombre', value: 'name' },
      { text: 'Fecha de creación', value: 'createdAt' },
      {text:'Acciones', value:'actions'}
    ],
    record: [],
  }),
  methods:{
    ...mapActions({
      editItem: 'UserType/get',
      deleteItem: 'UserType/clean',
      save: 'UserType/add',
      clearForm: 'UserType/clearForm',
    }),
  },
  computed:{
    title() { return this.UserType.selectedKey == '' ? 'Registar' : 'Crear' },
    titleButton() { return this.UserType.selectedKey == "" ? 'Guardar' : 'Editar' },
    ...mapGetters({
      userTypeRecord: 'UserType/recordTypeRole',
    }),
    ...mapState({
      data: state=> state.UserType.data,
      UserType :state=> state.UserType,
    })
  }
}
</script>

